<div class="container">

    <div class="actions">

        <mat-form-field appearance="fill">
            <mat-label>Templates</mat-label>
            <mat-select [(ngModel)]="template">
              <mat-option value="repairlab-rcti">Repair Lab RCTI</mat-option>
              <mat-option value="task-sheet">Task Sheet</mat-option>
              <mat-option value="invoice-standard">Standard</mat-option>
              <mat-option value="invoice-msp">MSP</mat-option>
              <mat-option value="invoice-ewaste">E-Waste</mat-option>
              <mat-option value="payout-ewaste">E-Waste Payout</mat-option>
            </mat-select>
          </mat-form-field>

        <div class="buttons">
            <button class="generate" mat-raised-button (click)="generateTestPDF()">Generate Test PDF</button>
            
            <button [disabled]="currentState != 'generated'" (click)="print()" mat-raised-button>Print</button>
            <button [disabled]="currentState != 'generated'" (click)="view()" mat-raised-button>View Template</button>
            <button [disabled]="currentState != 'generated'" (click)="download()" mat-raised-button>Download</button>
        </div>
    </div>

    <div class="viewer" #viewerWrapper>
        <div class="a4-frame" #frame [style.height.px]="frameHeight" [style.width.px]="frameWidth">
            <div *ngIf="currentState == 'no-generated'" class="placeholder">
                <div>Select a template and click "Generate Test PDF" to preview.</div>
                <div class="message" *ngIf="message">{{ message }}</div>
            </div>

            <div *ngIf="currentState == 'generating'" class="placeholder">
                <div>Generating preview…</div>
                <div class="message" *ngIf="message">{{ message }}</div>
            </div>

            <pdf-viewer
                *ngIf="currentState == 'generated'"
                [src]="pdfSrc"
                [render-text]="true"
                [fit-to-page]="true"
                [original-size]="false"
                [autoresize]="true"
                class="pdf-viewer"
            ></pdf-viewer>
        </div>
    </div>
</div>
